
import Vue from 'vue';
import Hero from '../components/WhoWeAre/Hero.vue';
import Video from '../components/Video.vue';
import Content from '../components/WhoWeAre/Content.vue';
import Partners from '../components/WhoWeAre/Partners.vue';
import Invite from '../components/WhoWeAre/Invite.vue';
export default Vue.extend({
  name: 'WhoWeAre',
  components: {
    Hero,
    Video,
    Content,
    Partners,
    Invite,
  },
});
